/**
 * Parses the given tint color alias into its CSS color value based on the theme and the specified
 * tint effect (either "lighten" or "darken").
 *
 * @param theme - The theme object.
 * @param effect - The tint effect to resolve a value for.
 * @param tone - The tint color alias to apply.
 */ function parseTintColor(theme, effect, tone) {
    return theme.aliases.tintColors[effect][tone];
}

export { parseTintColor };
//# sourceMappingURL=tint-color.js.map
